module.exports = __webpack_public_path__ + "files/21f6430fbd322d3ece6f5ed388d521e4.png";